import { animate, state, style, transition, trigger } from '@angular/animations'
import { Component } from '@angular/core'
import { GuideRoutingService } from '../service/guide-routing.service'

export const SlideInOutAnimation = [
  trigger('slideInOut', [
    state(
      'in',
      style({
        opacity: '1',
        visibility: 'visible',
      }),
    ),
    state(
      'out',
      style({
        'max-height': '0px',
        opacity: '0',
        visibility: 'hidden',
        padding: '0px 0 0px',
      }),
    ),
    transition('in => out', [
      animate(
        '200ms ease-in-out',
        style({
          opacity: '0',
        }),
      ),
      animate(
        '200ms ease-in-out',
        style({
          'max-height': '0px',
          padding: '0px 0 0px',
        }),
      ),
      animate(
        '200ms ease-in-out',
        style({
          visibility: 'hidden',
        }),
      ),
    ]),
    transition('out => in', [
      animate(
        '200ms ease-in-out',
        style({
          visibility: 'visible',
        }),
      ),
    ]),
  ]),
]
@Component({
  selector: 'flowaccount-guide-table',
  templateUrl: './guide-table.component.html',
  styleUrls: ['./guide-table.component.scss'],
  animations: [SlideInOutAnimation],
})
export class GuideTableComponent {
  groups$ = this.guideRoutingService.groupsWithActive$

  public animationState = {
    iosdev: 'out',
    androiddev: 'out',
    frontdev: 'out',
    QAdev: 'out',
    Devops: 'out',
    PM: 'out',
    DM: 'out',
    DCC: 'out',
    Support: 'out',
    SalesAd: 'out',
    HR: 'out',
  }

  constructor(private guideRoutingService: GuideRoutingService) {}

  openDetail($event, divName: string) {
    this.animationState[divName] = this.animationState[divName] === 'out' ? 'in' : 'out'
  }
  toggleGroupActive(group) {
    if (group.isExpand === undefined) {
      return (group.isExpand = !group.active)
    } else {
      group.isExpand = !group.isExpand
    }
  }

  getActive(group) {
    if (group.isExpand !== undefined) {
      return group.isExpand
    }
    return group.active
  }
}
